import * as React from "react";
import { Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import Calendar from "react-calendar";
import axiosInstance from "../../Config/axios";
import { API_URLS } from "../../Config/API_URLS";

export default function DateCalendarValue() {
  const [count, setCount] = useState(0);
  const [value1, setValue1] = useState("");
  const navigate = useNavigate();
  const { id, variant_id } = useParams();
  function increment() {
    //setCount(prevCount => prevCount+=1);
    setCount(function (prevCount) {
      return (prevCount += 1);
    });
  }

  function decrement() {
    setCount(function (prevCount) {
      if (prevCount > 0) {
        return (prevCount -= 1);
      } else {
        return (prevCount = 0);
      }
    });
  }

  const GetSubscriptionDaly = () => {
    const reqbody = new FormData();
    reqbody.append("subscription_plan_id", id);
    reqbody.append("product_variants_id", variant_id);
    reqbody.append("start_date", convert(value1));
    reqbody.append("select_quantity", count);
    axiosInstance
      .post(API_URLS.dailySubscription, reqbody)
      .then((response) => {
        alert(response?.data?.message);
        navigate("/subscription");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  console.log(convert(value1));
  return (
    <>
      <div className="mt-44">
        <Calendar onChange={setValue1} value={value1} />
      </div>

      <hr />
      <p className="font-bold my-5">Select Quantity</p>
      <div className="flex px-5 gap-5 my-5">
        <button
          onClick={increment}
          className="h-10 w-10 font-bold border bg-blue-600"
        >
          +
        </button>
        <p className="font-bold items-center m-auto text-xl">{count}</p>
        <button
          onClick={decrement}
          className="h-10 w-10 font-bold border bg-blue-600"
        >
          -
        </button>
      </div>

      <Button
        className="!my-3"
        onClick={GetSubscriptionDaly}
        variant="contained"
      >
        Confirm
      </Button>
    </>
  );
}
